import sensitiveCache from '@/utils/sensitive_cache'
import uuid from 'uuid/v4'
import { postMessage, postMessageResend } from '@/api/chat'
import {
    STATUS
} from '@/constants/message'
import {
    APPEND_MESSAGE,
    APPEND_MESSAGE_ONLY_FRONT_END,
    RESEND_MESSAGE,
    INSERT_MESSAGE,
} from '@/constants/pub_sub'
import { turnHumanServiceText } from '@/utils/message_send'

export default {
    methods: {
        // S chat 订阅事件
        bindChatSendEvents () {
            // 只向消息列表插入消息，不向服务器上传，用于微信语音消息 audio
            this.$eventBus.$on(APPEND_MESSAGE_ONLY_FRONT_END, data => {
                this.appendMessage(data.frontEnd)
            })
            // 新发消息
            this.$eventBus.$on(APPEND_MESSAGE, async (data) => {
                const message = this.appendMessage(data.frontEnd)
                const messageId = message.baseProps.id

                try {
                    const response = await postMessage(this.getPostData(data.backEnd))
                    this.postMessageSuccess(messageId, response)
                    
                    // 技能客服组转人工
                    if (turnHumanServiceText.includes(data.backEnd.data)) {
                        this.$refs.skillGroup.sendHumanService()
                    }
                    console.log('APPEND_MESSAGE', turnHumanServiceText, data.backEnd.data)
                } catch (err) {
                    this.postMessageFail(err, message)
                }
            })
            // 在特定消息后面插入一条消息
            this.$eventBus.$on(INSERT_MESSAGE, async (data, baseMessageId) => {
                const message = this.insertMessage(data.frontEnd, baseMessageId)
                const messageId = message.baseProps.id
                try {
                    const response = await postMessage(this.getPostData(data.backEnd))
                    this.postMessageSuccess(messageId, response)
                } catch (err) {
                    this.$eventBus.$emit('showinputstatus', {is_input:false})
                    this.postMessageFail(err, message)
                }
            })
            // 重发消息
            this.$eventBus.$on(RESEND_MESSAGE, async (data) => {
                const messageId = data.messageId
                const message = this.getMessageById(messageId)
                try {
                    let idFromServer = this.getMessageValueById(messageId, 'server.id')
                    const postData = this.getPostData(data.backEnd, idFromServer)
                    this.setMessageValueById(
                        messageId,
                        'baseProps.status',
                        STATUS.SENDING
                    )

                    const response = await postMessageResend(postData)
                    this.postMessageSuccess(messageId, response)
                } catch (err) {
                    this.postMessageFail(err, message, false)
                } finally {
                    this.scrollToMessage(message)
                }
            })
        },

        unbindChatSendEvents () {
            const events = [
                APPEND_MESSAGE,
                APPEND_MESSAGE_ONLY_FRONT_END,
                RESEND_MESSAGE,
                INSERT_MESSAGE
            ]
            events.forEach(event => {
                this.$eventBus.$off(event)
            })
        },

        /**
         * 组织待 post 的数据
         * @param { String } [idFromServer] - 重发消息时可能用到
         */
        getPostData (toPostMessage, idFromServer) {
            const common = {
                chat_user_id: this.uid,
                e: this.entryKey,
                source: this.$eventBus.chatSource,
                message: toPostMessage
            }
            let result = Object.assign({}, common)

            if (idFromServer) {
                Object.assign(result, {
                    msg_id: idFromServer
                })
            }

            return result
        },
        /**
         * 为消息设置 server 字段的内容
         */
        setMessageValueFromServer (messageId, {
            msg_id: idFromServer,
            created_at: timestamp
        }) {
            /**
             * 此处是首次设置 server 字段（即之前为 message.server 为 undefined）
             * 故可对整个 server 字段设值（不会覆盖整个 server 字段），
             * 而不是逐个字段设值，即 server.id = xx、server.timestamp = xx
             */
            let serverobj = {}
            if (this.chatTarget === 'human') {
                serverobj = {
                    id: idFromServer,
                    timestamp
                }
            } else {
                serverobj = {
                    id: idFromServer,
                    timestamp,
                    from: 'chat_user',
                    fromId: '0'
                }
            }
            this.setMessageValueById(messageId, 'server', serverobj)
        },

        replaceSensitiveText ({
            msg_id: idFromServer
        }, data) {
            if(data.code) {
                let database = {
                    baseProps:{
                        id:uuid()
                    }, content:{
                        text:data.msg
                    }, layout:{
                        isShowHost:false
                    }, name:'event_chat_notice'
                }
                this.messageList.push(database)
                this.scrollToMessage(database)
            }else{
                if (sensitiveCache.has(idFromServer)) {
                    this.setMessageValueByIdFromServer(
                        idFromServer,
                        'content.text',
                        sensitiveCache.get(idFromServer)
                    )
                    sensitiveCache.remove(idFromServer)
                }
            }
        },

        postMessageSuccess (messageId, response) {
            this.setMessageValueById(
                messageId,
                'baseProps.status',
                STATUS.SUCCESS
            )
            this.setMessageValueFromServer(messageId, response)
            this.replaceSensitiveText(response, response)
            this.messageList.forEach(item => {
                if (item.server) {
                    if (this.noreadmsgid.has(item.server.id)) {
                        item.baseProps.isUnread = true
                        this.noreadmsgid.delete(item.server.id)
                    }
                }
            })
        },

        postMessageFail (err, message, needScrollToMessage = true) {
            // eslint-disable-next-line
            console.error(err)

            const messageId = message.baseProps.id
            this.setMessageValueById(messageId, 'baseProps.status', STATUS.FAIL)

            if (needScrollToMessage) {
                this.scrollToMessage(message)
            }
        }
    },
    beforeDestroy () {
        this.unbindChatSendEvents()
    }
}
